import { connect } from 'react-redux'

import { findCinemaId, findEventId } from '../../global/helpers'

const mapStateToProps = (state) => {
    const eventid = findEventId(state)
    const cinemaid = findCinemaId(state)

    return {
        emptyBasket: !state?.components?.basket?.data?.items_tickets?.length ?? false,
        selectedPayment: state?.components?.basket?.data?.selected_payment ?? null,
        eventid,
        cinemaid,
        basketData: state?.components?.basket?.data ?? null,
    }
}

const mapDispatchToProps = {}

const hocContactInfo = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocContactInfo
